import { FunctionComponent, useEffect, useState } from 'react';

import CardFormStyles from './CardFormStyles';
import CardFormSchema from './CardFormValidationSchema';
import { CardInfoFields } from './CardFormTypes';
import { updateForm, validateForm } from '../FormHelpers';
import { emitErrors, messageReceived } from '../PostMessageHelpers';

const CardForm: FunctionComponent = () => {
  const [form, setForm] = useState<CardInfoFields>(new CardInfoFields());
  const queryParams = new URLSearchParams(window.location.search);
  const allowedThemes = ['white'];
  const theme = allowedThemes.find(e => e === queryParams.get('theme'));

  let formClassName = 'card-form';
  if (theme) {
    formClassName += `-${theme}`;
  }

  useEffect(() => {
    window.addEventListener('message', handleMessageReceived);
    async function emitReady() {
      emitErrors('ready', await validateForm(form, CardFormSchema));
    }
    emitReady();
    return () => {
      window.removeEventListener('message', handleMessageReceived);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleMessageReceived(event: MessageEvent) {
    messageReceived(event, form);
  }

  function handleEvent(event: any, eventType: string) {
    updateForm(event, eventType, form, setForm, CardFormSchema);
  }

  function handleBlur(event: any) {
    handleEvent(event, 'blur');
  }

  function handleChange(event: any) {
    handleEvent(event, 'change');
  }

  return (
    <>
      <CardFormStyles />
      <form className={formClassName}>
        <div className={'card-field--number'}>
          <input
            name="number"
            type="tel"
            placeholder="Card Number"
            minLength={12}
            maxLength={19}
            autoComplete='cc-number'
            autoCorrect='off'
            className={'card-form-input'}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        <div className={'card-field--month'}>
          <input
            name="month"
            type="tel"
            placeholder="MM"
            maxLength={2}
            autoComplete='cc-exp-month'
            autoCorrect='off'
            className={'card-form-input'}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        <div className={'card-field--date-divider'}>/</div>

        <div className={'card-field--year'}>
          <input
            name="year"
            type="tel"
            placeholder="YY"
            maxLength={2}
            autoComplete='cc-exp-year'
            autoCorrect='off'
            className={'card-form-input'}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        <div className={'card-field--cvv'}>
          <input
            name="verification"
            type="tel"
            placeholder="CVV"
            maxLength={4}
            autoComplete='cc-csc'
            autoCorrect='off'
            className={'card-form-input'}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
      </form>
    </>
  );
};

export default CardForm;
